import React, { useCallback } from 'react';
import firebase from 'firebase/app';
import { memoNamed } from '../utils/react/memo-named';

interface Props {
  start: firebase.firestore.Timestamp;
  end: firebase.firestore.Timestamp;
  deletePrivilege: (
    start: firebase.firestore.Timestamp,
    end: firebase.firestore.Timestamp
  ) => void;
}

const dateToString = (date: firebase.firestore.Timestamp): string => {
  const _year: string = date.toDate().getFullYear().toString();
  const _month: string = (date.toDate().getMonth() + 1).toString();
  const _date: string = date.toDate().getDate().toString();
  return `${_year}年${_month}月${_date}日`;
};

export const NamesPrivilegeInfo = memoNamed<Props>(
  'NamesPrivilegeInfo',
  (props) => {
    const buttonDeletePrivilege = useCallback(
      () => props.deletePrivilege(props.start, props.end),
      [props]
    );

    return (
      <tr>
        <td>
          {dateToString(props.start)}から{dateToString(props.end)}まで
        </td>
        <td>
          <button onClick={buttonDeletePrivilege}>削除</button>
        </td>
      </tr>
    );
  }
);
